export const REGISTER_MAPPING = 'URL/REGISTER_MAPPING'
export const SET_CURRENT_ROUTE = 'URL/SET_CURRENT_ROUTE'
export const SET_PREV_ROUTE = 'URL/SET_PREV_ROUTE'
export const IS_BACK_ROUTE = 'URL/IS_BACK_ROUTE'
